import { render, staticRenderFns } from "./buyChangeCard.vue?vue&type=template&id=f2ecdbf6&scoped=true&"
import script from "./buyChangeCard.vue?vue&type=script&lang=js&"
export * from "./buyChangeCard.vue?vue&type=script&lang=js&"
import style0 from "./buyChangeCard.vue?vue&type=style&index=0&id=f2ecdbf6&lang=less&scoped=true&"
import style1 from "./buyChangeCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ecdbf6",
  null
  
)

export default component.exports